import Button from 'components/generics/buttons/Button';
import MultiChoiceButtons from 'components/generics/buttons/MultiChoiceButtons';
import { FlowComponentProps } from 'components/generics/flows/Flow';
import Typography from 'components/generics/texts/Typography';
import { DEACTIVATION_REASONS } from 'pages/profile/components/ProfileTabContent/Account/Advanced/components/DeleteAccountModalFlow/DeleteAccountReview/utils';
import React, { useState } from 'react';
import classes from './index.module.scss';

const DeleteAccountReview = ({ onFinish }: FlowComponentProps) => {
  const [reasons, setReasons] = useState<string[]>([]);
  const onChangeReasons = (values: string[]) => setReasons(values);

  const onNext = () => onFinish({ reasons });

  return (
    <>
      <Typography className={classes.title}>
        We are sad to see you go.
      </Typography>
      <Typography className={classes.subtitle}>
        This is optional, but we&apos;d like to know why you closed your
        account.
      </Typography>
      <MultiChoiceButtons
        className={classes.buttonsContainer}
        buttons={DEACTIVATION_REASONS}
        buttonClassName={classes.pickButton}
        selectedButtonClassName={classes.pickButtonSelected}
        onChangeValues={onChangeReasons}
      />
      <Button
        className={classes.button}
        onClick={onNext}
      >
        Next
      </Button>
    </>
  );
};

export default DeleteAccountReview;
